module.exports = __webpack_public_path__ + "img/bmwk_transparent.b8e07eb1.png";